
import LoaderIcon from '../icons/LoaderIcon.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoaderComponent',
  components: {
    LoaderIcon
  },
  props: {
    message: {
      type: String,
      default: ''
    }
  }
})
